import {
    Box,
    Drawer,
    IconButton,
    Paper,
    Tooltip,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import {useEffect, useState, useMemo} from 'react'
import ListAltIcon from "@mui/icons-material/ListAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import HomeMadeDialog from "../dialogs/HomeMadeDialog";
import {useLingui} from "@lingui/react";
import {msg} from "@lingui/macro";
import httpReq from "../../services/httpReq";
import FullPageLoader from "../loaders/FullPageLoader";

const RightReportsListMenu = ({isOpen,selectedVideo,setIsOpen,setSelectedVideoReport,reportId}) => {
    const [isOpenDialog, setIsOpenDialog] = useState(false)
    const [reportToDelete, setReportToDelete] = useState(null)
    const [videoReports, setVideoReports] = useState([])
    const {_} = useLingui()
    const [isLoading, setIsLoading] = useState(false)

    // nuovo stato per l’ordinamento
    const [sortOption, setSortOption] = useState("date_desc");

    const formatTimeVideo = (report) => {
        const beginPlayTime = report.beginPlayTime;
        const endPlayTime = report.endPlayTime;
        const minBegin = Math.floor(beginPlayTime / 60);
        const secBegin = Math.floor(beginPlayTime % 60);
        let str = `${minBegin.toString().padStart(2, '0')}:${secBegin.toString().padStart(2, '0')}`;
        if(endPlayTime){
            const minEnd = Math.floor(endPlayTime / 60);
            const secEnd = Math.floor(endPlayTime % 60);
            str = str + ` - ${minEnd.toString().padStart(2, '0')}:${secEnd.toString().padStart(2, '0')}`
        }
        return str;
    };

    useEffect(() => {
        getVideoReports()
    }, [isOpen]);

    const getVideoReports = async (reportId = null) => {
        const res = await httpReq(`Report/GetList`, 'POST', {
            pageIndex: 0,
            pageSize: 0,
            videoFk: selectedVideo.id,
            tagValuesFk: []
        }, true)

        if (!res.responseAnyError) {
            setVideoReports(res.responseData)
            if (reportId) {
                const foundedReport = res.responseData.find(report => report.id === +reportId)
                setSelectedVideoReport(foundedReport)
            }
        }
    }

    const deleteReport = async (report) => {
        setIsLoading(true)
        const r = report
        const res = await httpReq(`Report/Delete/${r.id}`, 'DELETE', null, true)
        if (!res.responseAnyError) {
            getVideoReports()
            setIsOpenDialog(false)
            setIsLoading(false)
        }
    }

    const sortedReports = useMemo(() => {
        let sorted = [...videoReports];
        switch (sortOption) {

            case "time_asc":
                sorted.sort((a, b) => a.beginPlayTime - b.beginPlayTime);
                break;
            case "time_desc":
                sorted.sort((a, b) => b.beginPlayTime - a.beginPlayTime);
                break;
            default:
                break;
        }
        return sorted;
    }, [videoReports, sortOption]);

    return (
        <Drawer
            transitionDuration={400}
            anchor="right"
            open={isOpen}
            onClose={() => setIsOpen(false)}
        >
            <Box
                sx={{
                    width: 400,
                    height: '100%',
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    backgroundColor: '#f5f5f5',
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        p: 2,
                        borderRadius: 2,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" sx={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <ListAltIcon sx={{verticalAlign: 'middle', mr: 1}}/>
                        Reports List
                    </Typography>
                    <Typography variant="subtitle2">{selectedVideo?.title}</Typography>
                </Box>

                <FormControl size="small" fullWidth>
                    <InputLabel id="sort-label">{_(msg`Order by`)}</InputLabel>
                    <Select
                        labelId="sort-label"
                        value={sortOption}
                        label="Order by"
                        onChange={(e) => setSortOption(e.target.value)}
                    >
                        <MenuItem value="time_asc">{_(msg`Video time (asc)`)}</MenuItem>
                        <MenuItem value="time_desc">{_(msg`Video time (desc)`)}</MenuItem>
                    </Select>
                </FormControl>

                {/* LISTA REPORTS */}
                <Box sx={{overflowY: 'auto', display: 'flex', height: '100%', flexDirection: 'column', gap: 1}}>
                    {sortedReports.map((report, key) => (
                        <Paper
                            key={key}
                            elevation={3}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 2,
                                backgroundColor: key % 2 === 0 ? 'white' : '#fafafa',
                                animation: `fadeInUp 0.3s ease-out ${key * 0.05}s`,
                                animationFillMode: 'forwards',
                                opacity: 0,
                                transition: 'transform 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                    boxShadow: 6,
                                },
                            }}
                        >
                            <Box sx={{flex: 2}}>
                                <Typography variant="body2" color="text.primary">
                                    {report.title}
                                </Typography>
                                <Typography variant='caption' color='text.secondary'>
                                    video time: {formatTimeVideo(report)}
                                </Typography>
                            </Box>

                            <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                                <Tooltip title="View Report">
                                    <IconButton
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            setSelectedVideoReport(report);
                                            setIsOpen(false);
                                        }}
                                    >
                                        <VisibilityIcon/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete Report">
                                    <IconButton
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            setIsOpenDialog(true)
                                            setReportToDelete(report)
                                        }}
                                    >
                                        <DeleteIcon color='error'/>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Paper>
                    ))}
                </Box>
            </Box>
            {isOpenDialog && <HomeMadeDialog
                isOpen={isOpenDialog}
                labelClose={'Cancel'}
                labelConfirm={'Confirm'}
                text={_(msg`Are you sure?`)}
                fnClose={() => setIsOpenDialog(false)}
                fnConfirmAction={() => deleteReport(reportToDelete)}
                title={`Delete report`}/>}

            {isLoading && <FullPageLoader/>}
        </Drawer>
    );
};
export default RightReportsListMenu;
